import styled from 'styled-components';

import { ColorsTypes } from '~/ui/theme/colors';
import { Button, Typography } from '~/ui/components';
import { themeColor, themeToggleColor } from '~/common/utils/theme';

interface PalettedProps {
  colorPalette?: ColorsTypes;
}

export const PopoverHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 0 24px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.divider.primary};

  svg {
    height: 20px;
    width: 20px;
    cursor: pointer;
    color: ${themeColor('brand.primary', { dark: 'brand.primaryAlt' })};
  }
`;

export const Title = styled(Typography).attrs(({ theme }) => ({
  type: 'paragraphLarge',
  weight: 500,
  color: themeToggleColor(theme, 'element.primary', { dark: 'element.secondary' }),
}))``;

export const CloseButton = styled(Button).attrs(({ theme }) => ({
  variant: 'text',
  icon: 'Close',
  size: 'sm',
  customColor: themeToggleColor(theme, 'brand.primary', { dark: 'brand.primaryAlt' }),
}))`
  background-color: ${themeColor('background.secondary')};
  border-radius: 12px;
  padding: 20px;
  position: relative;
  width: 40px;
  height: 40px;

  svg {
    color: ${themeColor('element.primary')};
    position: absolute;
    width: 24px;
    height: 24px;
  }
`;
